import styled, { keyframes } from 'styled-components';
import { Card } from 'antd';

export const VisualMemoryBox = styled.div`
    position: relative;
    background: #222;
    border-radius: 4px;
    width: 304px;
    height: 340px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const GameBoard = styled.div<{ columns: number }>`
    display: grid;
    grid-template-columns: repeat(${props => props.columns}, 1fr);
    width: 300px;
    height: 300px;
    padding: 3px;
    border-radius: 4px;
    background: #fff;
`;

function renderBg(hidden: boolean, typed: boolean, highlight: boolean) {
    if (highlight) {
        return 'orange';
    }
    if (hidden) {
        return '#13293d';
    } else {
        if (typed) {
            return '#34d57d';
        }
        return '#b6332b';
    }
}

interface ITileBox {
    hidd: boolean;
    rotated: boolean;
    typed: boolean;
    highlight: boolean;
}

export const tileAnimationTime = 300;

export const TileBox = styled.div<ITileBox>`
    transform: rotateX(0deg) translateZ(1px);
    transition: all ${tileAnimationTime}ms ease-out 0s;
    background-color: ${props => renderBg(props.hidd, props.typed, props.highlight)};
    margin: 2px;
    border-radius: 6px;
    ${props => props.rotated && `transform: rotateY(180deg) translateZ(1px);`}
`;

export const HeartBox = styled.div`
    padding-left: 5px;
    padding-right: 5px;
    width: 79px;
    & span {
        font-size: 23px;
        color: #b6332b;
    }
`;

export const InfoBarBox = styled.div`
    display: flex;
    flex: 1;
    color: #fff;
    justify-content: space-between;
    align-items: center;
`;

export const LivesBox = styled.div``;

export const LevelBox = styled.div`
    font-size: 17px;
    padding-left: 5px;
`;

export const BoardBox = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: 2px;
`;

const levelKeyframes = keyframes`
    0%    { opacity: 0; }
    10%   { opacity: 1; }
    90%   { opacity: 1; }
    100%  { opacity: 0; }
`;

const gameOverKeyframes = keyframes`
    0%    { opacity: 0; }
    100%  { opacity: 1; }
`;

export const levelAnimationTime = 1400;

export const LevelAnimation = styled(Card)`
    background: #34d57d;
    position: absolute;
    top: 38px; bottom: 2px;
    left: 2px; right: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    border-radius: 4px;
    color: #FFF;
    font-size: 20px;
    z-index: 9999;
    animation: ${levelKeyframes} ${levelAnimationTime}ms ease-in-out 1;
`;

export const GameOverAnimation = styled(Card)`
    background: #b6332b;
    position: absolute;
    top: 38px; bottom: 2px;
    left: 2px; right: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    color: #FFF;
    font-size: 20px;
    z-index: 9999;
    animation: ${gameOverKeyframes} 200ms ease-in-out 1;
`;

export const GameOverInfoBox = styled.div`
    display: flex;
    font-size: 16px;
    flex-direction: column;
    align-items: center;
`;

export const GameOverRow = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding-bottom: 5px;
`;

export const GameOverButton = styled.div`
    margin-top: 5px;
    width: 100%;
`;
